<template>
  <div class="liquor-index">
    <Header active="/liquor" :style="`background: rgba(0, 0, 0, ${ headeroOpacity });`" />

    <div class="banner" :style="`transform: matrix(1, 0, 0, 1, 0, ${f});`">
      <Background :style="`opacity: ${opacity};`" />
    </div>

    <Category />
    <Brand />
    <Daily />
    <HomeCopyright />
  </div>
</template>

<script>
import Header from "@/components/liquor/Header";
import WorldMap from "@/components/liquor/WorldMap";
import Background from "@/components/liquor/Background";
import Daily from "@/components/liquor/Daily";
import Category from "@/components/liquor/Category";
import Brand from "@/components/liquor/Brand";
import HomeCopyright from "@/components/index/HomeCopyright";

export default {
  name: "LiquorIndex",
  components: {
    Header,
    WorldMap,
    Background,
    Daily,
    Category,
    Brand,
    HomeCopyright
  },
  data() {
    return {
      scrollTop: 0
    };
  },
  computed: {
    f: function() {
      return -this.scrollTop / 4;
    },
    opacity: function() {
      return (1000 - this.scrollTop) / 1000;
    },
    headeroOpacity: function() {
      return this.scrollTop > 500 ? 1 : 0;
    }
  },
  created() {
    window.addEventListener("scroll", this.handleScroll, true);
  },
  methods: {
    handleScroll(e) {
      this.scrollTop = e.target.documentElement.scrollTop;
    }
  }
};
</script>

<style lang="scss">
.liquor-index {
  width: 100%;

  .liquor-header-parent {
    opacity: 1;
  }

  .banner {
    background: black;
  }
  // overflow-x: hidden;
}
</style>